<template>
    <div v-cloak v-if="auth">
        <div class="row mb-3">
            <div class="col-12">
                <div class="row form-group">
                    <div class="col-12"><label for="template-search">{{ $lang('Nazwa szablonu:') }}</label></div>
                    <div class="col-8 col-md-10">
                        <input
                            class="form-control d-inline-block w-100 w-md-auto mr-3"
                            id="template-search"
                            type="text"
                            v-model="search"
                            @keydown="searchInputKeyDown"
                            :placeholder="$lang('Wyszukaj szablon') + '...'"
                        >
                    </div>
                    <div class="col-4 col-md-2 form-group">
                        <button class="btn btn-primary btn-block text-nowrap" @click.prevent="searchButtonClick">
                            <span>{{ $lang('Szukaj') }}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <pagination-component
            :pagination="pagination"
            :key="'pagination-1-'+ (pagination.current_page ? pagination.current_page : 1)"
        ></pagination-component>
        <div class="simple-table structure-table" v-if="templatesList.length">
            <table class="table table-striped table-sm table-hover mb-0">
                <table-headers :headers="tableHeaders"></table-headers>
                <tbody>
                    <tr v-for="(template, index) in templatesList">
                        <td :data-title="$lang('Lp.')">
                            {{ pagination.from + index }}
                        </td>
                        <td :data-title="$lang('Nazwa')">
                            <span href="">{{ template.name }}</span>
                        </td>
                        <td :data-title="$lang('Akcje')">
                            <a :href="editUrl(template.id)"
                               class="mx-1"
                               :title="$lang('Edytuj szablon')  + ': ' +  template.name"
                               :aria-label="$lang('Edytuj szablon') + ': ' +  template.name">
                                {{ $lang('Edytuj') }}
                            </a>
                            <a href="#"
                               class="mx-1"
                               data-toggle="modal"
                               :data-target="'#modalConfirmation-' + template.id"
                               :title="$lang('Usuń szablon')  + ': ' +  template.name"
                               :aria-label="$lang('Usuń szablon') + ': ' +  template.name">
                                {{ $lang('Usuń') }}
                            </a>
                            <div class="modal" :id="'modalConfirmation-' + template.id" tabindex="-1" role="dialog"
                                 :aria-labelledby="'modalConfirmation-' + template.id + '-label'" aria-hidden="true">
                                <div class="modal-dialog" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h5 class="modal-title" :id="'modalConfirmation-' + template.id + '-label'">
                                                {{$lang('Usunięcie Szablonu')}}
                                            </h5>
                                            <button type="button" class="close" data-dismiss="modal" :aria-label="$lang('Zamknij')">
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                        <div class="modal-body">
                                            {{ $lang('Czy na pewno chcesz usunąć szablon "')}}
                                            <strong>{{ template.name }}</strong>" ?
                                        </div>
                                        <div class="modal-footer">
                                            <a href="#" class="btn btn-default" data-dismiss="modal">{{$lang('Nie')}}</a>
                                            <a href="#" class="btn btn-primary" @click.prevent="confirm(template.id)" data-dismiss="modal">{{$lang('Tak')}}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div v-else>
            {{ $lang('Brak wyników') }}
        </div>
        <pagination-component
            :pagination="pagination"
            :key="'pagination-2-'+ (pagination.current_page ? pagination.current_page : 1)"
        ></pagination-component>
    </div>
</template>
<script>

    import axios from 'axios';
    import Notification from '../../../mixins/show-notification';
    import { EventBus } from "../../../mixins/event-bus";
    import TableHeaders from '../../table/table-headers';
    import PaginationComponent from '../../pagination-component';

    export default {

        name: 'templates-table',

        components: {
            TableHeaders,
            PaginationComponent,
        },

        mixins: [Notification],

        props: {
            auth: {
                type: Boolean,
                required: true
            },
            list_route: {
                type: String,
            },
            templates_route: {
                type: String,
            },
        },

        data() {
            return {
                templatesList: [],
                pagination: [],
                perPage: 20,
                sortColumn: 'name',
                sortOrder: 'asc',
                search: '',
                tableHeaders: [
                    {title: this.$lang('Lp.')},
                    {title: this.$lang('Nazwa'), column: 'name', sort: 'alpha'},
                    {title: this.$lang('Akcje')}
                ],
            };
        },
        created() {
            this.setEventBusListeners();
            this.requestTemplates();
        },

        watch: {
            libraryID() {
                this.requestTemplates();
            },
            sortColumn() {
                this.requestTemplates();
            }
        },

        methods: {
            editUrl(id) {
                return this.templates_route + '/edit' + '/' + id;
            },

            confirm(id) {
                this.deleteTemplate(id);
            },

            requestTemplates(filters) {
                const params = {
                    ...filters,
                    perPage: this.perPage,
                    search: this.search,
                    sortColumn: this.sortColumn,
                    sortOrder: this.sortOrder
                };

                return axios.get(this.list_route, {params}).then(response => {
                    this.templatesList = response.data.data;
                    this.pagination = response.data;
                }).catch((error) => {
                    const message = (error.response.data ? error.response.data : error.response.statusText);
                    this.showNotification('error', message);
                });
            },

            searchInputKeyDown(event) {
                if (event.keyCode === 13) {
                    this.requestTemplates();
                }
            },

            searchButtonClick() {
                this.requestTemplates();
            },

            setEventBusListeners() {
                EventBus.$on('changePage', ({ value }) => {
                    this.requestTemplates({ page: value });
                });

                EventBus.$on('sortByColumn', ({ column, order }) => {
                    this.sortColumn = column;
                    this.sortOrder = order;

                    this.requestTemplates({ page: this.pagination.current_page });
                });
            },

            deleteTemplate(id) {
                return axios.post(this.templates_route +'/delete' + '/' + id).then((response) => {
                    this.requestTemplates({ page: this.pagination.current_page });
                    this.showNotification('success', this.$lang('Usunięto szablon') + '.');
                }).catch((error) => {
                    const message = (error.response.data ? error.response.data : error.response.statusText);
                    this.showNotification('error', message.message.toString());
                }).then(() => {
                });
            },
        }
    }

</script>
